import Styles from "./Search.module.scss"
import {ReactComponent as NavIcon} from '../../../../icons/extra_icons/left.svg'

const SpotifyCards=[
  {
    id:0,
    label:"Podcats",
    bgColor:"E13201",
    imageLink:"",
  },
  {
    id:1,
    label:"Live Events",
    bgColor:"7358FF",
    imageLink:"",
  },
  {
    id:2,
    label:"Made For You",
    bgColor:"1F3265",
    imageLink:"",
  },
  {
    id:3,
    label:"New Releases",
    bgColor:"E8115B",
    imageLink:"",
  },
  {
    id:4,
    label:"Hindi",
    bgColor:"E81428",
    imageLink:"",
  },
  {
    id:5,
    label:"Pujabi",
    bgColor:"B12896",
    imageLink:"",
  },
  {
    id:6,
    label:"Tamil",
    bgColor:"A46753",
    imageLink:"",
  },
  {
    id:7,
    label:"Telugu",
    bgColor:"D94001",
    imageLink:"",
  },
  {
    id:8,
    label:"Charts",
    bgColor:"8D67AB",
    imageLink:"",
  },
  {
    id:9,
    label:"Pop",
    bgColor:"148A08",
    imageLink:"",
  },
  {
    id:10,
    label:"Indie",
    bgColor:"148A08",
    imageLink:"",
  },
  {
    id:11,
    label:"Trending",
    bgColor:"B12896",
    imageLink:"",
  },
  {
    id:12,
    label:"Love",
    bgColor:"E71F32",
    imageLink:"",
  },
  {
    id:13,
    label:"Discover",
    bgColor:"8D67AB",
    imageLink:"",
  },
  {
    id:14,
    label:"Mood",
    bgColor:"8D67AB",
    imageLink:"",
  },
  {
    id:15,
    label:"Party",
    bgColor:"527AA0",
    imageLink:"",
  },
  {
    id:16,
    label:"Devotional",
    bgColor:"527AA0",
    imageLink:"",
  },
  {
    id:17,
    label:"Decades",
    bgColor:"527AA0",
    imageLink:"",
  },
  {
    id:18,
    label:"Hip-Hop",
    bgColor:"BD5800",
    imageLink:"",
  },
  {
    id:19,
    label:"Dance/Electronic",
    bgColor:"D94001",
    imageLink:"",
  },
  {
    id:20,
    label:"Students",
    bgColor:"D94001",
    imageLink:"",
  },
  {
    id:21,
    label:"Chill",
    bgColor:"D94001",
    imageLink:"",
  },
  {
    id:22,
    label:"Gaming",
    bgColor:"E8115B",
    imageLink:"",
  },
  {
    id:23,
    label:"K-Pop",
    bgColor:"148A08",
    imageLink:"",
  },
  {
    id:24,
    label:"Workout",
    bgColor:"148A08",
    imageLink:"",
  },
  {
    id:25,
    label:"RADAR",
    bgColor:"767776",
    imageLink:"",
  },
  {
    id:26,
    label:"EQUAL",
    bgColor:"056952",
    imageLink:"",
  },
  {
    id:27,
    label:"Fresh FInds",
    bgColor:"FF0090",
    imageLink:"",
  },
  {
    id:28,
    label:"Rock",
    bgColor:"E81428",
    imageLink:"",
  },
]


const SearchScreen = () => {
  return (
    <div className={Styles.container}>
        <div className={Styles.top_bar}>
          <div className={Styles.button}><NavIcon width={20} height={20}/></div>
          <div className={Styles.button} style={{transform:"rotate(180deg"}}><NavIcon width={20} height={20}/></div>
          <input type="text" className={Styles.search_text} placeholder={"🔍 What do you want to listen to?"}/>
        </div>
        <div className={Styles.header}>
          Browse All
        </div>
        <div className={Styles.cards}>
            {
              SpotifyCards.map((card)=>{
                return (
                  <div className={Styles.card}  style={{backgroundColor:`#${card.bgColor}`}} key={card.id} >
                      <div className={Styles.label}>
                        {card.label}
                      </div>
                  </div>
                )
              })
            }
        </div>
    </div>
  )
}


export default SearchScreen
